import { useInRouterContext, useLocation, useNavigate } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { useAuth } from '@/auth/session';
import { APP_ROUTES } from '@/navigation';
import { useStore } from '@/state/store';
import type { FeedbackKind } from '@/data/feedback';

type Props = {
  kind?: FeedbackKind;
  bar?: number;
  onOpen?: () => void;
  className?: string;
  children?: React.ReactNode;
};
export function FeedbackLink(props: Props) {
  const auth = useAuth();
  const inRouter = useInRouterContext();
  return auth.status === 'active' && inRouter ? <FeedbackButton {...props} /> : null;
}
function FeedbackButton({
  kind = 'general',
  bar,
  onOpen,
  className = 'btn btn-sm btn-ghost',
  children,
}: Props) {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        const state = useStore.getState();
        const selected = state.score.form.findIndex((m) => m.id === state.selectedMeasureId) + 1;
        onOpen?.();
        navigate(APP_ROUTES.feedback, {
          state: {
            kind,
            route: location.pathname,
            bar: bar ?? (kind === 'tune' && selected > 0 ? selected : undefined),
          },
        });
      }}
    >
      <MessageSquare size={16} aria-hidden="true" /> {children ?? 'Feedback'}
    </button>
  );
}
